import { Modal } from "../modal/Modal";
import { Button } from "../button/Button";
import { useIsMedia } from "src/apps/hooks/useIsMedia";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { useRef } from "react";

type LogoutModalProps = {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export const LogoutModal = ({ isOpen, onConfirm, onClose }: LogoutModalProps) => {
  const { t } = useTranslations();
  const { isDesktop } = useIsMedia();
  const initialFocusRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title={t("documentation_area.logout_modal.title")}
        body={t("documentation_area.logout_modal.body")}
        primaryButton={
          <Button
            onClick={onConfirm}
            text={t("documentation_area.logout_modal.confirm")}
            variant="danger"
            fitContent={isDesktop}
          />
        }
        secondaryButton={
          <Button
            onClick={onClose}
            text={t("common.cancel")}
            variant="ghost"
            fitContent={isDesktop}
            ref={initialFocusRef}
          />
        }
        initialFocusRef={initialFocusRef}
      />
    </>
  );
};
